import { IconButton, Tooltip } from "@mui/material";
import React, { Component } from "react";
import CloseIcon from "@mui/icons-material/Close";

export default class AgActionButtonRenderor extends Component {
  constructor(props) {
    super(props);
    this.checkedHandler = this.checkedHandler.bind(this);
  }
  checkedHandler(event) {
    let checked = event.target.checked;
    let colId = this.props.column.colId;
    this.props.node.setDataValue(colId, checked);
  }
  onChange(evebt) {}
  render() {
    return (
      <>
        {this.props.data.product && (
          <Tooltip title={"Remove"}>
            <IconButton color="secondary">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  }
}
